import { createTextFilterMeta } from '#/modules/commonComponents/table/columnFilterMeta';
import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';

function displayDash(value) {
  if (value == null || value === '') {
    return '—';
  }
  return value;
}

/**
 * RepairItemPickerDialog 用欄（無導航連結）。
 * 表頭文字 filter 會經 listQuery → API snake query；
 * 效力依後端 `GET …/repair-item/search` 欄位 filter
 *（見 docs/handoff/2026-10-01_01_BACKEND_AFTERSALES_REPAIR_ITEM_SEARCH_FILTERS.md）。
 *
 * @param {{ filters?: object, onFilterChange?: (key: string, value: unknown) => void }} [options]
 */
export function buildRepairItemPickerColumns({
  filters = {},
  onFilterChange = () => {},
} = {}) {
  return [
    {
      id: 'serialNo',
      header: '序號',
      accessorKey: 'serialNo',
      size: 128,
      enableSorting: false,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'serialNo',
          label: '序號',
          filterValue: filters.serialNo,
          onChange: (value) => onFilterChange('serialNo', value),
          placeholder: '搜尋序號',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={displayDash(row.original?.serialNo)} />
      ),
    },
    {
      id: 'productCode',
      header: '產品代號',
      accessorKey: 'productCode',
      size: 120,
      enableSorting: false,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'productCode',
          label: '產品代號',
          filterValue: filters.productCode,
          onChange: (value) => onFilterChange('productCode', value),
          placeholder: '搜尋產品代號',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={displayDash(row.original?.productCode)} />
      ),
    },
    {
      id: 'itemName',
      header: '品名',
      accessorKey: 'itemName',
      size: 160,
      enableSorting: false,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'itemName',
          label: '品名',
          filterValue: filters.itemName,
          onChange: (value) => onFilterChange('itemName', value),
          placeholder: '搜尋品名',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={displayDash(row.original?.itemName)} />
      ),
    },
    {
      id: 'repairRequestNo',
      header: '報修單號',
      accessorKey: 'repairRequestNo',
      size: 140,
      enableSorting: false,
      enableColumnFilter: true,
      meta: createTextFilterMeta({
        key: 'repairRequestNo',
        label: '報修單號',
        filterValue: filters.repairRequestNo,
        onChange: (value) => onFilterChange('repairRequestNo', value),
        placeholder: '搜尋報修單號',
      }),
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={displayDash(row.original?.repairRequestNo)} />
      ),
    },
    {
      id: 'problemDescription',
      header: '問題描述',
      accessorKey: 'problemDescription',
      size: 180,
      enableSorting: false,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'problemDescription',
          label: '問題描述',
          filterValue: filters.problemDescription,
          onChange: (value) => onFilterChange('problemDescription', value),
          placeholder: '搜尋問題描述',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip
          text={displayDash(row.original?.problemDescription)}
        />
      ),
    },
    {
      id: 'accessories',
      header: '配件',
      accessorKey: 'accessories',
      size: 120,
      enableSorting: false,
      enableColumnFilter: false,
      meta: { cellClassName: 'td_left' },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip
          text={displayDash(row.original?.accessories)}
          contentClassName="whitespace-pre-line"
        />
      ),
    },
    {
      id: 'remark',
      header: '備註',
      accessorKey: 'remark',
      size: 140,
      enableSorting: false,
      enableColumnFilter: true,
      meta: {
        cellClassName: 'td_left',
        ...createTextFilterMeta({
          key: 'remark',
          label: '備註',
          filterValue: filters.remark,
          onChange: (value) => onFilterChange('remark', value),
          placeholder: '搜尋備註',
        }),
      },
      cell: ({ row }) => (
        <TruncatedTextWithTooltip text={displayDash(row.original?.remark)} />
      ),
    },
  ];
}

export const REPAIR_ITEM_PICKER_SORT_FIELD_LABELS = {
  serialNo: '序號',
  productCode: '產品代號',
  itemName: '品名',
  repairRequestNo: '報修單號',
  problemDescription: '問題描述',
  remark: '備註',
};
